var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMixerGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.13 65.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#25e544;stroke-linecap:round;stroke-miterlimit:10;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.5,
    y1: 62.63,
    x2: 2.5,
    y2: 14.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.53,
    y1: 62.63,
    x2: 17.53,
    y2: 29.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.57,
    y1: 62.63,
    x2: 32.57,
    y2: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.6,
    y1: 62.63,
    x2: 47.6,
    y2: 19.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 62.63,
    y1: 62.63,
    x2: 62.63,
    y2: 39.67
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixerGreen);
export default __webpack_public_path__ + "static/media/MixerGreen.2e10c0b435ebb1a881ea97d991b33bc8.svg";
export { ForwardRef as ReactComponent };